import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c4c1210"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile" }

import { computed } from 'vue';
import { useAppState, useGameState, useNetworkState } from '@/services/composition';

import CompanionMap from '@/components/CompanionMap.vue'
import CompanionSync from '@/components/CompanionSync.vue'
import CompanionTuto from '@/components/CompanionTuto.vue'
import CompanionIntro from '@/components/CompanionIntro.vue'
import CompanionPause from '@/components/CompanionPause.vue'
import CompanionEnding from '@/components/CompanionEnding.vue'
import CompanionOverlays from '@/components/CompanionOverlays.vue'
import CompanionDebugView from '@/components/CompanionDebugView.vue'
import CompanionDualChoice from '@/components/CompanionDualChoice/CompanionDualChoice.vue'
import CompanionRotate from '@/components/CompanionRotate.vue';
import CompanionDisconnect from '@/components/CompanionDisconnect.vue';
import UIPagePanel from "@/components/UIPagePanel/UIPagePanel.vue";
import type { pagePanelId } from "@/services/stores/page-panels";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()
const { state: appState, send } = useAppState()
const networkState = useNetworkState()

const isSync = computed(() => {
  return appState.value.matches('sync')
})

const isDisconnected = computed(() => {
  return networkState.value.context.actorCount !== 2
})

const DEBUG = computed(() => {
  return !!(process.env.VUE_APP_DEBUG?.toLowerCase?.() === 'true' || process.env.VUE_APP_DEBUG === true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "long-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CompanionMap),
        _createVNode(CompanionOverlays),
        _createVNode(_Transition, {
          name: "medium-fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_unref(state).context.isPaused)
              ? (_openBlock(), _createBlock(CompanionPause, { key: "companion-pause" }))
              : (_unref(isSync))
                ? (_openBlock(), _createBlock(CompanionSync, { key: "companion-sync" }))
                : (_unref(state).matches('intro'))
                  ? (_openBlock(), _createBlock(CompanionIntro, { key: "companion-intro" }))
                  : (_unref(state).matches('tuto'))
                    ? (_openBlock(), _createBlock(CompanionTuto, { key: "companion-tuto" }))
                    : (_unref(state).matches('end'))
                      ? (_openBlock(), _createBlock(CompanionEnding, { key: "companion-ending" }))
                      : (_unref(isDisconnected))
                        ? (_openBlock(), _createBlock(CompanionDisconnect, { key: "companion-disconnected" }))
                        : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_unref(appState).context.pagePanelId)
          ? (_openBlock(), _createBlock(UIPagePanel, {
              key: _unref(appState).context.pagePanelId,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(send)({ type: 'SET_PAGE_PANEL', id: null }))),
              onRedirect: _cache[1] || (_cache[1] = (slug) => _unref(send)({ type: 'SET_PAGE_PANEL', id: slug }))
            }))
          : _createCommentVNode("", true),
        (_unref(DEBUG))
          ? (_openBlock(), _createBlock(CompanionDebugView, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(CompanionRotate)
      ])
    ]),
    _: 1
  }))
}
}

})